module.exports = __webpack_public_path__ + "img/naan2.e1dc1837.jpg";